// import { defineStore } from "pinia";
// export const useAuthStore=defineStore('auth',{
//     state: () => ({
//         isAuthenticated: false,
//         userLogin: false
//       }),
//       getters: {
//         getAuth() {
//           return this.isAuthenticated
//         },
//         getUserLogin() {
//           return this.userLogin
//         }
//       },
//       actions: {
//         register() {
//           this.isAuthenticated = true
//             localStorage.setItem('auth', JSON.stringify(true))
//         },
//         logout() {
//           this.isAuthenticated = false
//             localStorage.setItem('auth', JSON.stringify(false))
         
//         },
//         userLogin() {
//           this.userLogin = true
//         },
//         userLogout() {
//           this.userLogin = false
//         },
//         initializeStore() {
//             const auth = localStorage.getItem('auth')
//             if (auth) {
//               this.isAuthenticated = JSON.parse(auth)
//             }
        
//         }
//       }
// })
import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    isAuthenticated: false,
    userLogin: false,
  }),
  getters: {
    getAuth() {
      return this.isAuthenticated;
    },
    getUserLogin() {
      return this.userLogin;
    },
  },
  actions: {
    register() {
      this.isAuthenticated = true;
      localStorage.setItem("auth", JSON.stringify(true));
    },
    logout() {
      this.isAuthenticated = false;
      localStorage.removeItem("auth"); // Remove from storage
    },
    userLogin() {
      this.userLogin = true;
      localStorage.setItem("userLogin", JSON.stringify(true));
    },
    userLogout() {
      this.userLogin = false;
      localStorage.removeItem("userLogin"); // Remove from storage
    },
    initializeStore() {
      const auth = localStorage.getItem("auth");
      if (auth) {
        this.isAuthenticated = JSON.parse(auth);
      }

      const userLogin = localStorage.getItem("userLogin");
      if (userLogin) {
        this.userLogin = JSON.parse(userLogin);
      }
    },
  },
});

